// import React, { useEffect, useState, useContext } from 'react';
// import './OverallShares.css';
// import axios from 'axios';
// import { FilterContext } from './FilterContext'; // Import FilterContext
// import Filters from './Filters';
// import config from '../../config';
// import { useNavigate } from 'react-router-dom';
// import './PaymentMethodViews.css';

// const BrandShare = () => {
//     const { selectedFilters, DisplayFiltersName } = useContext(FilterContext);
//     const [tableData, setTableData] = useState([]); // Holds table data
//     const [loading, setLoading] = useState(true); // Loading state
//     const [error, setError] = useState(null); // Error state
//     const [dataSummary, setDataSummary] = useState(null); // Data summary state
//     const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('Debit');
//     const [apiCalled, setApiCalled] = useState(false);


//     const navigate = useNavigate(); // Hook for navigation

//     // Fetch table data based on selected filters
//     useEffect(() => {
//         if (selectedFilters && Object.keys(selectedFilters).length > 0) {
//             const filteredFilters = Object.fromEntries(
//               Object.entries(selectedFilters).filter(([key, value]) => Array.isArray(value) && value.length > 0)
//           );
//           if (Object.keys(filteredFilters).length > 0) {
//             setLoading(true);
//             setApiCalled(false);
//             setTableData([]);
//             axios
//                 .post(`${config.API_BASE_URL}/api/payment-method-view`, filteredFilters)
//                 .then((response) => {
//                     setTableData(response.data || []);
//                     // console.log("response", response)
//                     // console.log("tableData", tableData)
//                     setApiCalled(true);
//                     setLoading(false);
//                 })
//                 .catch((err) => {
//                     console.error('Error fetching table data:', err);
//                     setError('Failed to load data.');
//                     setApiCalled(true);
//                     setLoading(false);
//                 });
//         } }else {
//             // Handle the case when there are no selected filters
//             setLoading(false);
//             setTableData([]);
//             setApiCalled(false);
//         }
//     }, [selectedFilters]);

//     // Fetch data summary for total transactions

//     useEffect(() => {
//         if (selectedFilters && Object.keys(selectedFilters).length > 0) {
//         // Filter the selectedFilters to remove empty arrays
//         const filteredFilters = Object.fromEntries(
//             Object.entries(selectedFilters).filter(([key, value]) => 
//                 Array.isArray(value) && value.length > 0
//             )
//         );

//         if (Object.keys(filteredFilters).length > 0) {
//             // Pass the filtered filters as where_clause for filtering
//             const whereClause = JSON.stringify(filteredFilters);

//             fetch(`${config.API_BASE_URL}/api/data-summary`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({
//                     where_clause: whereClause, // Pass filtered filters as the where_clause
//                 }),
//             })
//                 .then((response) => response.json())
//                 .then((data) => {
//                     setDataSummary(data);
//                     setLoading(false);
//                 })
//                 .catch((error) => {
//                     console.error('Error fetching data summary:', error);
//                     setError('Failed to fetch data summary');
//                     setLoading(false);
//                 });
//         } }else {
//             setDataSummary([]);
//         }
//     }, [selectedFilters]);





//     const cleanPaymentMethodName = (name) => {
//         return name
//             .replace(/_/g, ' ')
//             .replace(/%-|%/g, '')
//             .replace(/-Total$/, '')
//             .replace(/-Debit$/, '')
//             .replace(/-Credit$/, '')
//             .replace(/-Interac$/, '')
//             .replace(/-Visa$/, '')
//     };

//     // Filter tableData based on the selected payment method
//     // Filter tableData based on the selected payment method
//     const filteredTableData = selectedPaymentMethod === 'All'
//         ? tableData
//         : tableData.filter((item) => {
//             // Always include 'Base' row
//             if (item.payment_method.includes('Base')) {
//                 return true;
//             }
//             return item.payment_method.includes(selectedPaymentMethod); // Include the selected method
//         });

//     // Extract unique payment methods, ensuring "Base" is always included
//     const paymentMethods = [
//         ...new Set(
//             filteredTableData
//                 .map((item) => item.payment_method)
//                 .filter((method) => {
//                     // Exclude "Visa Debit" and "Visa Credit" for Debit and Credit selections
//                     if (selectedPaymentMethod === 'Debit') {
//                         return !/( Debit| Credit)/.test(method); // Exclude Visa Debit
//                     }
//                     if (selectedPaymentMethod === 'Credit') {
//                         return !/( Debit| Credit)/.test(method); // Exclude Visa Credit
//                     }
//                     if (selectedPaymentMethod === 'Total') {
//                         return !/(Total )/.test(method); // Exclude Total
//                     }
//                     return true; // Include all other methods
//                 })
//         )
//     ];

//     // Add 'Base' method if it's not already in the list of payment methods
//     if (!paymentMethods.includes('Base')) {
//         paymentMethods.push('Base');
//     }


//     // const paymentMethods = [
//     //     ...new Set(  
//     //         filteredTableData
//     //             .map((item) => item.payment_method)
//     //             .filter((method) => !/( Debit| Credit)/.test(method)) 
//     //     ),
//     // ];
//     const years = [...new Set(filteredTableData.map(item => item.year))].sort((a, b) => b - a);

//     // Create structuredTableData using years and paymentMethods
//     const structuredTableData = years.map(year => {
//         return {
//             year,
//             data: paymentMethods.map(paymentMethod => {
//                 // Find the corresponding entry for each year and paymentMethod
//                 const entry = filteredTableData.find(
//                     item => item.year === year && item.payment_method === paymentMethod
//                 );
//                 // Return the percentage if found, otherwise 0
//                 // return entry ? entry.percentage : 0;
//                 return entry
//                     ? {
//                         percentage: entry.percentage,
//                         total_trans_count: entry.total_trans_count || 0,
//                     }
//                     : { percentage: 0, total_trans_count: 0 };
//             })
//         };
//     });



//     const goBack = () => {
//         navigate('/dashboards'); // Go back to the previous page/tab
//     };

//     const renderSelectedFilters = () => {
//         let renderedTransYear = false; // Flag to track if 'trans_year' has been rendered
//         const subCategoryValues = []; // To accumulate sub-category values
//         const renderContent = [];

//         // Loop through the filter names and render them
//         Object.keys(DisplayFiltersName).map((displayName) => {
//           const filterKey = DisplayFiltersName[displayName]; // Get the object for the current display name

//           // If the filterKey is an array (like 'trans_year' or any other arrays), handle them
//           if (Array.isArray(filterKey)) {
//             // If it's 'trans_year' and has not been rendered, render it
//             if (displayName === "trans_year" && !renderedTransYear) {
//               renderedTransYear = true;
//               renderContent.push(
//                 <span key={displayName} className="selected-filter">
//                   <strong>Year: </strong>{filterKey.join(", ")}
//                 </span>
//               );
//             }
//             return; // Skip further handling for arrays (no need to process this again)
//           }

//           // Get the keys from the filterKey object (like user_age, user_gender)
//           const filterKeys = Object.keys(filterKey);

//           // Loop through each filter key (like user_age, user_gender)
//           filterKeys.map((key) => {
//             const filterValues = selectedFilters[key];

//             // Skip rendering if filterValues is empty or undefined
//             if (!filterValues || (Array.isArray(filterValues) && filterValues.length === 0)) {
//               return null;
//             }

//             // Skip rendering 'trans_year' if it's already been rendered
//             if (key === "trans_year" && renderedTransYear) {
//               return; // Skip if 'trans_year' has already been rendered
//             }

//             // Special handling for sub-categories
//             if (displayName === "Sub-Categories" || key.startsWith("SubCat_")) {
//               if (Array.isArray(filterValues)) {
//                 subCategoryValues.push(...filterValues); // Collect sub-category values
//               } else {
//                 subCategoryValues.push(filterValues);
//               }
//               return null; // Skip rendering immediately
//             }

//             // For other filters, display the regular displayName
//             const displayKey = key === "trans_year" ? "Year" : displayName;
//             const displayValues = Array.isArray(filterValues) ? filterValues.join(", ") : filterValues;

//             renderContent.push(
//               <span key={key} className="selected-filter">
//                 <strong>{displayKey}: </strong>{displayValues}
//               </span>
//             );
//           });
//         });

//         // Render the combined sub-categories at the end, only if they exist
//         if (subCategoryValues.length > 0) {
//           renderContent.push(
//             <span key="sub-categories" className="selected-filter">
//               <strong>Sub-Categories: </strong>{subCategoryValues.join(", ")}
//             </span>
//           );
//         }

//         return renderContent;
//       };




//     return (
//         <div className="container">
//             <Filters pageSpecificFilters="payment" />
//             {/* Dropdown for selecting Payment Method */}
//             <div className="table-section">
//                 {/* Back Button */}
//                 <button onClick={goBack} className="back-button">
//                     &#8592;  Back
//                 </button>
//                 {/* Render selected filters before FilterTabs */}
//                 <div className="selected-filters-display">
//                     {renderSelectedFilters()}
//                 </div>
//                 <div>
//                     <div className="dropdown-section">
//                         <label htmlFor="paymentMethod">Payment Method View:</label>
//                         <select
//                             id="paymentMethod"
//                             value={selectedPaymentMethod || 'Debit'}  // Ensure selectedPaymentMethod is a valid scalar
//                             onChange={(e) => setSelectedPaymentMethod(e.target.value)}
//                         >
//                             {/* <option value="All">All</option> */}
//                             <option value="Credit">Credit</option>
//                             <option value="Debit">Debit Total</option>
//                             <option value="Interac">Interac Debit</option>
//                             <option value="Visa">Visa Debit</option>
//                             {/* <option value="Total">Total</option> */}
//                         </select>
//                     </div>
//                 </div>

//                 <div>
//                     <table>
//                         <thead>
//                             <tr>
//                                 <th className="total-transac">
//                                     <u>Total Transactions</u>
//                                     <br />
//                                     <label className="label">
//                                         <i>
//                                             <strong>Base:</strong> {dataSummary?.trans?.toLocaleString()}
//                                         </i>
//                                     </label>
//                                 </th>
//                                 <th className="share-column">Share of Transactions</th>
//                             </tr>
//                         </thead>
//                     </table>
//                 </div>

//                 {loading ? (
//                     <div className="loader-container">
//                         <div className="loader"></div>
//                     </div>
//                 ) : error ? (
//                     <p className="error">{error}</p>
//                 ) : (!loading && apiCalled && tableData.length === 0 && Object.keys(selectedFilters).length > 0 && !error) ? (
//                     // Show this message only if no data is returned AND filters are applied
//                     <p className="no-data">No data available for the selected filters.</p>
//                 ) : (
//                     <div className='tablesview'>
//                         <div>
//                             {loading ? (
//                                 <div className="loader-container">
//                                     <div className="loader"></div>
//                                 </div>
//                             ) : error ? (
//                                 <p className="error">{error}</p>
//                             ) : (
//                                 <div>{/* Render filtered table */}</div>
//                             )}
//                         </div>

//                         <table>
//                             <thead>
//                                 <tr>
//                                     <th>Payment Methods</th>
//                                     {years.map(year => (
//                                         <th key={year}>{year}</th>
//                                     ))}
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {paymentMethods.map(paymentMethod => {

//                                     const isBaseRow = paymentMethod.includes('Base');
//                                     const isTotal = paymentMethod.includes('-Total');
//                                     return (
//                                         <tr key={paymentMethod}
//                                             className={
//                                                 `${isTotal
//                                                     ? 'blue-row'
//                                                     : (
//                                                         paymentMethod.includes('Interac Debit') || paymentMethod.includes('Interac E-transfer')
//                                                     )
//                                                         ? 'special-row'
//                                                         : (
//                                                             paymentMethod.includes('Interac In-person') || paymentMethod.includes('Interac Virtual') || paymentMethod.includes('Interac e-Transfer Virtual')
//                                                         )
//                                                             ? 'gray-row'
//                                                             : (
//                                                                 (paymentMethod.includes('Debit') || paymentMethod.includes('Credit') || paymentMethod.includes('Interac') ||
//                                                                     paymentMethod.includes('Visa') || paymentMethod.includes('Mastercard'))
//                                                                 && (paymentMethod.includes('In-person') || paymentMethod.includes('Virtual')
//                                                                     || paymentMethod.includes('Plastic Card ') || paymentMethod.includes('Phone-tap') || paymentMethod.includes('E-Commerce'))
//                                                             )
//                                                                 ? 'special-row'
//                                                                 : (
//                                                                     (paymentMethod.includes('Using app or browser') || paymentMethod.includes('Phone-tap')) ||
//                                                                     (paymentMethod.includes('Website on mobile device') || paymentMethod.includes('Website on browser') || paymentMethod.includes('App on mobile device'))
//                                                                 )
//                                                                     && (paymentMethod.includes('Debit') || paymentMethod.includes('Credit') || paymentMethod.includes('Interac') || paymentMethod.includes('Visa'))
//                                                                     ? 'sub-special-row'
//                                                                     : (
//                                                                         (paymentMethod.includes('Debit') || paymentMethod.includes('Credit') || paymentMethod.includes('Interac') ||
//                                                                             paymentMethod.includes('Interac In-person') || paymentMethod.includes('Interac Virtual') ||
//                                                                             paymentMethod.includes('Interac e-Transfer Virtual') || paymentMethod.includes('Total M-Comm') || paymentMethod.includes('Total E-Comm'))
//                                                                     )
//                                                                         ? 'gray-row'
//                                                                         : ''
//                                                 } ${paymentMethod.includes('M-Commerce') ? 'gray-row' : ''} 
//                                                  ${paymentMethod.includes('Website on PC browser') ? 'gray-row' : ''} 
//                                                 ${isBaseRow ? 'base-row' : ''}`}
//                                         >
//                                             {/* <td>{paymentMethod.replace('-Total', '')}</td> */}
//                                             {/* Update this column to show the special text for Base */}
//                                             <td>
//                                                 {isBaseRow ? <i>Base: Weighed number of transactions</i> : cleanPaymentMethodName(paymentMethod)}
//                                             </td>
//                                             {/* {structuredTableData.map(row => (
//                                                 <td key={row.year}>
//                                                     {
//                                                         // Check if value is valid before calling toFixed
//                                                         (() => {
//                                                             const value = row.data[paymentMethods.indexOf(paymentMethod)];
//                                                             return value != null && !isNaN(value)
//                                                                 ? `${value.toFixed(1)}%`
//                                                                 : 'N/A';
//                                                         })()
//                                                     }
//                                                 </td>
//                                             ))} */}
//                                             {structuredTableData.map((row) => {
//                                                 const rowData = row.data[paymentMethods.indexOf(paymentMethod)];
//                                                 const totalTransCount = rowData?.total_trans_count;
//                                                 const percentage = rowData?.percentage;
//                                                 return (
//                                                     <td key={row.year}>
//                                                         {isBaseRow
//                                                             ? totalTransCount != null && !isNaN(totalTransCount)
//                                                                 ? <i>{`${totalTransCount.toLocaleString()}`}</i>
//                                                                 : 'N/A'
//                                                             : percentage != null && !isNaN(percentage)
//                                                                 ? `${percentage.toFixed(1)}%`
//                                                                 : 'N/A'}
//                                                     </td>
//                                                 );
//                                             })}
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>
//                         </table>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default BrandShare;

import React, { useEffect, useState, useContext, useMemo } from 'react';
import './OverallShares.css';
import axios from 'axios';
import { FilterContext } from './FilterContext'; // Import FilterContext
import Filters from './Filters';
import config from '../../config';
import { useNavigate } from 'react-router-dom';
import './PaymentMethodViews.css';

const PaymentMethodViews = () => {
  const { selectedFilters, DisplayFiltersName } = useContext(FilterContext);
  const [brands, setBrands] = useState([]);
  const [data, setData] = useState([]);
  const [waves, setWaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [apiCalled, setApiCalled] = useState(false);
  const navigate = useNavigate();
  const [baseValue, setBaseValue] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('Debit');
  const [isDownloading, setIsDownloading] = useState(false);


  useEffect(() => {
    if (selectedFilters && Object.keys(selectedFilters).length > 0) {
      const filteredFilters = Object.fromEntries(
        Object.entries(selectedFilters).filter(([key, value]) => Array.isArray(value) && value.length > 0)
      );

      if (Object.keys(filteredFilters).length > 0) {
        setLoading(true);
        setApiCalled(false);

        axios
          .post(`${config.API_BASE_URL}/api/Overallshares`, {
            selectedFilters,
            groupId: 4,
          })
          .then((response) => {
            const { Brands, Data, Waves } = response.data;
            setBrands(response.data.Brands || []);
            setData(response.data.Data || []);
            setWaves(response.data.Waves || []);
            if (response.data.Data?.length > 0) {
              const seenWindex = new Set();
              let totalBase = 0;

              for (let i = 0; i < response.data.Data.length; i++) {
                const item = response.data.Data[i];
                if (!seenWindex.has(item.windex)) {
                  totalBase += item.Base || 0;
                  seenWindex.add(item.windex);
                }
              }
              const roundedBase = Math.round(totalBase);
              setBaseValue(roundedBase.toLocaleString());
            }
            // console.log('Brands:', Brands);
            // console.log('Data:', Data);
            // console.log('Waves:', Waves);
            setApiCalled(true);
            setLoading(false);
          })
          .catch((err) => {
            console.error('Error fetching data:', err);
            setError('Failed to load data.');
            setApiCalled(true);
            setLoading(false);
          });
      }
    } else {
      setLoading(false);
      setData([]);
      setApiCalled(false);
    }
  }, [selectedFilters]);


  const goBack = () => navigate('/dashboards');

  const renderSelectedFilters = () => {
    let renderedTransYear = false; // Flag to track if 'trans_year' has been rendered
    const subCategoryValues = []; // To accumulate sub-category values
    const renderContent = [];
    const brandValues = [];

    // Loop through the filter names and render them
    Object.keys(DisplayFiltersName).map((displayName) => {
      const filterKey = DisplayFiltersName[displayName]; // Get the object for the current display name

      // If the filterKey is an array (like 'trans_year' or any other arrays), handle them
      if (Array.isArray(filterKey)) {
        // If it's 'trans_year' and has not been rendered, render it
        if (displayName === "trans_year" && !renderedTransYear) {
          renderedTransYear = true;
          renderContent.push(
            <span key={displayName} className="selected-filter">
              <strong>Year: </strong>{filterKey.join(", ")}
            </span>
          );
        }
        return; // Skip further handling for arrays (no need to process this again)
      }

      // Get the keys from the filterKey object (like user_age, user_gender)
      const filterKeys = Object.keys(filterKey);

      // Loop through each filter key (like user_age, user_gender)
      filterKeys.map((key) => {
        const filterValues = selectedFilters[key];

        // Skip rendering if filterValues is empty or undefined
        if (!filterValues || (Array.isArray(filterValues) && filterValues.length === 0)) {
          return null;
        }

        // Skip rendering 'trans_year' if it's already been rendered
        if (key === "trans_year" && renderedTransYear) {
          return; // Skip if 'trans_year' has already been rendered
        }

        // ✅ Handle Sub-Categories
        if (displayName === "Sub-Categories" || key.startsWith("SubCat_")) {
          if (Array.isArray(filterValues)) {
            subCategoryValues.push(...filterValues);
          } else {
            subCategoryValues.push(filterValues);
          }
          return null;
        }

        // ✅ Handle Brand
        if (displayName === "Brand" || key.startsWith("Brand_")) {
          if (Array.isArray(filterValues)) {
            brandValues.push(...filterValues);
          } else {
            brandValues.push(filterValues);
          }
          return null;
        }

        // For other filters, display the regular displayName
        const displayKey = key === "trans_year" ? "Year" : displayName;
        const displayValues = Array.isArray(filterValues) ? filterValues.join(", ") : filterValues;

        renderContent.push(
          <span key={key} className="selected-filter">
            <strong>{displayKey}: </strong>{displayValues}
          </span>
        );
      });
    });

    // ✅ Render Sub-Categories
    if (subCategoryValues.length > 0) {
      renderContent.push(
        <span key="sub-categories" className="selected-filter">
          <strong>Sub-Categories: </strong>{subCategoryValues.join(", ")}
        </span>
      );
    }

    // ✅ Render Brand
    if (brandValues.length > 0) {
      renderContent.push(
        <span key="brand" className="selected-filter">
          <strong>Brand: </strong>{brandValues.join(", ")}
        </span>
      );
    }

    return renderContent;
  };
  const filteredBrands = useMemo(() => {
    if (!brands || brands.length === 0) return [];

    const selected = selectedPaymentMethod;

    // Exact match on Name + Order === 1
    const startIndex = brands.findIndex(
      (b) => b.Name === selected && b.order === 1
    );

    if (startIndex === -1) return [];

    const result = [];

    for (let i = startIndex; i < brands.length; i++) {
      const brand = brands[i];
      if (i === startIndex || brand.order === 0) {
        result.push(brand);
      } else {
        break;
      }
    }

    return result;
  }, [brands, selectedPaymentMethod]);

  const filteredData = useMemo(() => {
    if (!data || !filteredBrands) return [];

    return data.filter((d) => {
      for (let i = 0; i < filteredBrands.length; i++) {
        if (d.bindex === filteredBrands[i].Index) {
          return true;
        }
      }
      return false;
    });
  }, [data, filteredBrands]);

  const downloadTableData = async (selectedFilters) => {
    if (!data || !data.length) {
      alert("No data available to download.");
      return;
    }
    setIsDownloading(true); // show popup

    try {
      const kpi = "Payment Method Views"
      const response = await axios.post(
        `${config.API_BASE_URL}/download-data`,  // Replace with your actual API endpoint
        {
          selectedFilters: selectedFilters,
          Kpi: kpi,
          groupId: 4
        },
        { responseType: 'blob' } // Ensures file download
      );

      // Create a download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', kpi + '.xlsx'); // Change file name/format if needed
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading data:", error);
      alert("Failed to download data. Please try again.");
    } finally {
      setIsDownloading(false); // hide popup
    }
  };

  useEffect(() => {
    if (isDownloading) {
      document.body.classList.add('download-active');
    } else {
      document.body.classList.remove('download-active');
    }
  }, [isDownloading]);


  return (
    <div className="container">
      <Filters pageSpecificFilters="payment" />
      <div className="table-section">
        <div style={{ justifyContent: 'space-between', display: 'flex' }}>
          <button onClick={goBack} className="back-button">← Back</button>
          <button
            onClick={() => downloadTableData(selectedFilters)}
            className={`download-button ${!data?.length ? 'disabled' : ''}`}
            disabled={!data?.length}
          >
            <i className="fa fa-download"></i>&nbsp;
            <span className="download-text">Download Data</span>
          </button>
        </div>

        <div className="selected-filters-display">
          {renderSelectedFilters()}
        </div>
        <div>
          <div className="dropdown-section">
            <label htmlFor="paymentMethod">Payment Method View:</label>
            <select
              value={selectedPaymentMethod}
              onChange={(e) => setSelectedPaymentMethod(e.target.value)}
              style={{ marginBottom: '10px' }}
            >
              <option value="Credit">Credit</option>
              <option value="Debit">Debit Total</option>
              <option value="Interac Debit">Interac Debit</option>
              <option value="Visa Debit">Visa Debit</option>
              <option value="Mastercard Debit">Mastercard Debit</option>
              <option value="Co-Badge Total">Co-Badge Total</option>
            </select>

          </div>
        </div>
        {loading && (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )}

        {error && <div className="error">{error}</div>}

        {!loading && apiCalled && (
          <div>
            {data.length === 0 ? (
              <div className="no-data-message">
                No data to display for selected filter.
              </div>
            ) : (
              <div className="scrollable-table">
                <table>
                  <thead>
                    <tr>
                      <th className="total-transac">
                        <u>Total Transactions</u>
                        <br />
                        <label className="label">
                          <i><strong>Base:</strong> {baseValue}</i>
                        </label>
                      </th>
                      <th className="share-column" colSpan={waves.length}>Share of Transactions</th>
                    </tr>
                    <tr>
                      <th>Payment Methods</th>
                      {waves.map((wave) => (
                        <th key={wave.Id}>{wave.Name}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="base-row">
                      <td><strong><i>Base: Weighed number of transactions</i></strong></td>
                      {waves.map((wave) => {
                        const value = filteredData.find(d => d.windex === wave.Index);
                        return (
                          <td key={`base-${wave.Id}`}>
                            {value && value.Base !== undefined ? Math.round(value.Base).toLocaleString() : '-'}
                          </td>
                        );
                      })}
                    </tr>
                    {filteredBrands.map((brand) => (
                      <tr key={brand.Id} style={{ backgroundColor: `${brand.Color}`, textIndent: `${brand.Operator}` }}>
                        <td>{brand.Name}</td>
                        {waves.map((wave) => {
                          const value = filteredData.find(d => d.bindex === brand.Index && d.windex === wave.Index);
                          return (
                            <td key={`${brand.Id}-${wave.Id}`}>
                              {value && value.Perc !== undefined && parseFloat(value.Perc) > 0
                                ? `${(Math.round(parseFloat(value.Perc) * 10) / 10).toFixed(1)}%`
                                : '-'}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

      </div>
      {isDownloading && (
        <div className="download-popup">
          <div className="popup-content">
            <div className="spinner"></div>
            <p>Preparing your download...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentMethodViews;
